import { DETAILS_CONTENT_KEYS, IPlanContent, KeyDetailsItem } from '../typings/planContent.types';
import { createPlanNameMatcher, getKeyDetailsContentIcon } from './utils/PlanMetaHelper';
import {
  defaultEstimatesDialog,
  dualKeyDetailsAddons,
  electricityKeyDetailsAddons,
  gasKeyDetailsAddons,
} from './common/planDefaults';

import { InternetOfferPerk } from './common/internetOfferPerk';
import { BatteryStarterPerk } from './common/BatteryStarterPerk';
import { PlanKeyDetailsModal } from './common/PlanKeyDetailsModal';
import { BattStarterEligibilityCriteriaModal } from './common/BattStarterEligibilityCriteriaModal';

const PLAN_TONE = 'promote';

const defaultKeyDetails: KeyDetailsItem[] = [
  {
    contentKey: DETAILS_CONTENT_KEYS.Rates,
    contentValue: 'Variable + time of use',
    modalContent: PlanKeyDetailsModal,
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.Rates),
    contentDescription: 'Variable + time of use',
  },
  {
    contentKey: DETAILS_CONTENT_KEYS.ExitFees,
    contentValue: 'No',
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.ExitFees),
    contentDescription: 'No exit fees. Leave anytime.',
  },
  {
    contentKey: DETAILS_CONTENT_KEYS.BenefitPeriod,
    contentValue: '12 months, No lock ins',
    contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.BenefitPeriod),
    contentDescription: '12 month benefit period',
  },
];

export const originBatteryStarterContent: IPlanContent = {
  test: createPlanNameMatcher(['Origin Battery Starter']),
  content: {
    rateDiscountText: {
      defaultState: {
        defaultFuel: 'Rates variable on a 12 month benefit period', // TODO check if this is correct for solar boost with battery lite
      },
    },
    bannerContent: undefined,
    keyFeatures: {
      defaultState: {
        defaultFuel: [],
      },
    },
    signUpOptions: {
      defaultState: {
        defaultFuel: [],
      },
    },
    keyDetails: {
      defaultState: {
        defaultFuel: defaultKeyDetails,
        dual: [
          {
            contentKey: DETAILS_CONTENT_KEYS.EligibilityCriteiria,
            contentValue: 'Eligibility criteria applies',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.EligibilityCriteiria),
            modalContent: BattStarterEligibilityCriteriaModal,
            contentDescription: 'Eligibility criteria applies',
          },
          ...defaultKeyDetails,
        ],
        electricity: [
          {
            contentKey: DETAILS_CONTENT_KEYS.EligibilityCriteiria,
            contentValue: 'Eligibility criteria applies',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.EligibilityCriteiria),
            modalContent: BattStarterEligibilityCriteriaModal,
            contentDescription: 'Eligibility criteria applies',
          },
          ...defaultKeyDetails,
        ],
        gas: [
          {
            contentKey: DETAILS_CONTENT_KEYS.EligibilityCriteiria,
            contentValue: 'Eligibility criteria applies',
            contentIcon: getKeyDetailsContentIcon(DETAILS_CONTENT_KEYS.EligibilityCriteiria),
            modalContent: BattStarterEligibilityCriteriaModal,
            contentDescription: 'Eligibility criteria applies',
          },
          ...defaultKeyDetails,
        ],
      },
    },
    keyDetailsAddons: {
      defaultState: {
        defaultFuel: [],
        dual: dualKeyDetailsAddons,
        gas: gasKeyDetailsAddons,
        electricity: electricityKeyDetailsAddons,
      },
    },
    perkAccordion: {
      defaultState: {
        dual: [BatteryStarterPerk, InternetOfferPerk],
        gas: [BatteryStarterPerk, InternetOfferPerk],
        electricity: [BatteryStarterPerk, InternetOfferPerk],
        defaultFuel: [],
      },
    },
    promoBox: {
      defaultState: {
        defaultFuel: undefined,
      },
    },
    estimatesDialog: defaultEstimatesDialog(),
    uiOptions: {
      defaultState: {
        defaultFuel: {
          planColor: {
            text: {
              styleGuide: 'blue',
              odsCore: PLAN_TONE,
            },
            promobox: {
              styleGuide: 'blue',
              odsCore: PLAN_TONE,
            },
            bannerText: {
              styleGuide: 'white',
              odsCore: 'white',
            },
          },
          imageUrl:
            'https://res.cloudinary.com/originenergy/image/upload/v1728624900/spot-illustrations/spot_Origin-Solar-Boost.svg',
          imageForFuelType: {
            electricity:
              'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-battery-starter.svg',
            dual: 'https://www.originenergy.com.au/cdn/images/originenergy/image/upload/CP/plans/cp_origin-battery-starter.svg',
          },
          applyPromoBorder: false,
        },
      },
    },
    tagLine: {
      defaultState: {
        defaultFuel: 'Simple energy plan when you want to stay in control of your battery.',
      },
    },
    termsAndConditionsUrl: {
      defaultState: {
        defaultFuel: '/terms-and-conditions/origin-battery-starter-terms-and-conditions/',
      },
    },
  },
};
